import { Card, Description, HoverCard, HoverCardContent, HoverCardTrigger } from "@peer-start/ui/reducate";
import { useTranslation } from "react-i18next";
import type { SourceContribution, SourceFit } from "../pages/situation-card-view.js";

const tone: Record<SourceFit, { className: string; label: string }> = {
  fits: { className: "text-[var(--chart-4)]", label: "administration.situationCard.fitFits" },
  partial: { className: "text-[var(--chart-2)]", label: "administration.situationCard.fitPartial" },
  unused: { className: "text-[var(--destructive-solid)]", label: "administration.situationCard.fitUnused" },
};

export function SourceFitBadge({ id, contribution }: { id: string; contribution: SourceContribution }) {
  const { t, i18n } = useTranslation();
  const style = tone[contribution.level];
  const sections = new Intl.ListFormat(i18n.language, { style: "long", type: "conjunction" }).format(
    contribution.sections.map((section) => t(`administration.situationCard.slots.${section}`)),
  );
  const explanation =
    contribution.level === "unused"
      ? t("administration.situationCard.fitUnusedDetail")
      : t("administration.situationCard.fitContributes", { sections });
  return (
    <HoverCard closeDelay={150} openDelay={200}>
      <HoverCardTrigger asChild>
        <button
          className={`shrink-0 rounded-sm text-xs font-medium focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/30 ${style.className}`}
          data-control-id={`situation.sources.fit.${id}`}
          type="button"
        >
          {t(style.label)}
        </button>
      </HoverCardTrigger>
      <HoverCardContent align="start" className="w-72" side="right">
        <Card className="shadow-md" padding="compact">
          <Description>{explanation}</Description>
        </Card>
      </HoverCardContent>
    </HoverCard>
  );
}
